import React from 'react';
import { Modal,message } from 'antd';
export default {
    key: 'productMatch-action',
    build(stub) {
        class ProductMatchAction extends React.Component {
            constructor(props) {
                super(props);
                this.state = {
                    data: {},
                    model: {},
                    selectKeys: [],
                    distributorId:'',
                    productName:'',
                    specification:'',
                    specificationKeyword:'',
                    nameKeyword:'',
                    currentPage:1,
                    totalPage:0,
                    pageSize:5
                };
            }

            onSelectChange = (selectKeys) => {
                console.log(selectKeys);
                this.setState({
                    selectKeys
                })
            }

            onClick = e => {
                //点击匹配
                e.stopPropagation();
                const { model } = this.props;
                this.setState({
                    distributorId:model.distributorId,
                    productName:model.productName,
                    specification:model.specification,
                })
                this.show(true);
                this.dataHandle()
            };

            dataHandle = (url,param) => {
                if(url&&param){
                    stub.api.post(url,param).then(res => {
                        if (res) {
                            this.setState({
                                data: res.data.result,
                                totalPage:res.data.result.page.total,
                            })
                        }
                    })
                }else{
                    stub.api.get(
                        stub.module.cleanProductMatch.masterProductList).then(res => {
                        if (res) {
                            this.setState({
                                data: res.data.result,
                                totalPage:res.data.result.page.total,
                            })
                        }
                    })
                }


            };

            matchDataSearch = () => {
                const {model} = this.props;
                console.log(this)
                this.setState({
                    currentPage:1,
                    nameKeyword:model.nameSearch,  //搜索后再点击分页发起请求时用到
                    specificationKeyword:model.specificationSearch
                })
                let param={
                    filter:{
                        name:model.nameSearch,
                        specification:model.specificationSearch,
                    },
                    page:{
                        current:1,
                        pageSize:this.state.pageSize
                    }
                }
                this.dataHandle(stub.module.cleanProductMatch.masterProductSearch,param)
            }

            show = isVisible => {
                this.setState({visible: isVisible})
            };

            onCancel=(e)=>{
                this.show(false);
                this.setState({
                    model: {},
                    selectKeys: [],
                    distributorId:'',
                    productName:'',
                    specification:'',
                    specificationKeyword:'',
                    nameKeyword:'',
                    currentPage:1,
                })
            }

            onOk = (e) => {
                e.stopPropagation();
                if (this.state.selectKeys.length !== 0) {
                    let params={
                        distributorId: this.state.distributorId,
                        productId: this.state.selectKeys[0],
                        productName: this.state.productName,
                        specification:this.state.specification
                    }
                    console.log(params)
                    stub.api.post(stub.module.cleanProductMatch.productSubmit,params).then(res => {
                        if(res) {
                            message.success('提交成功')
                            this.show(false)
                            this.props.page.data = { ...res.data.result };
                            stub.store.dispatch({type: stub.constant.actionTypes.DUMMY_ACTION})
                        }else{
                            message.error('提交失败')
                        }
                    })
                }else{
                    message.warning('请选择后再提交')
                    return false;
                }
            };

            onTableChange = (page, sorter) => {
                this.setState({
                    currentPage:page.current
                })
                let param={
                    filter:{
                        name:this.state.nameKeyword,
                        specification:this.state.specificationKeyword,
                    },
                    page:{
                        pageSize:page.pageSize,
                        current:page.current
                    }
                }
                this.dataHandle(stub.module.cleanProductMatch.masterProductSearch,param)
            }

            render() {
                const { field, field: { label } } = this.props;
                const rowSelection = {
                    onChange: this.onSelectChange,
                    selectedRowKeys: this.state.selectKeys,
                    selectable: true,
                    type: 'radio'
                }
                return (
                    <div style={{display: 'inline-block'}}>
                        <span style={{color: '#FF9300', cursor: 'pointer'}}
                              onClick={e => {
                                  this.onClick(e)
                              }}>{stub.filter.transform(label)}</span>
                        <Modal
                            destroyOnClose={true}
                            visible={this.state.visible}
                            title='匹配项'
                            okText= {stub.filter.transform('common.submit')}
                            cancelText= {stub.filter.transform('common.cancel')}
                            onOk={this.onOk}
                            onCancel={this.onCancel}
                            width="60%"
                            onRef={ref => this.tips = ref}
                            field={ field }
                        >

                            <stub.ui.SceneContainer
                                module="cleanProductMatch"
                                sceneKey='cleanData-masterProduct-filter'
                                options={{
                                    ...this.props,
                                    onRef: ref => this.form = ref,
                                    onFieldChange: this.matchDataSearch,
                                }}
                            />

                            <stub.ui.SceneContainer
                                module="cleanProductMatch"
                                sceneKey='cleanData-masterProduct-list'
                                options={{
                                    ...this.props,
                                    data: this.state.data,
                                    rowSelection,
                                    onTableChange: this.onTableChange
                                }}
                            />
                        </Modal>
                    </div>)
            }
        }

        return ProductMatchAction;
    }
}
